import { createRootRoute, createRoute, createRouter, RouterProvider, Outlet, createHashHistory } from "@tanstack/react-router";
import "./index.css";
import { JobList } from "./JobList";
import { JobDetail } from "./JobDetail";

// Use hash history in production for GitHub Pages compatibility
const isProduction = process.env.NODE_ENV === 'production';
const hashHistory = createHashHistory();

// Root route with layout
const rootRoute = createRootRoute({
  component: () => (
    <div className="max-w-7xl mx-auto p-8 relative z-10">
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-2">Healthcare AI Benchmarks</h1>
        <p className="text-gray-600">Visualize and analyze benchmark run logs</p>
      </div>
      <Outlet />
    </div>
  ),
});

// Index route
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: JobList,
});

// Job detail route with optional trial search param
const jobDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/jobs/$jobId",
  component: JobDetail,
  validateSearch: (search: Record<string, unknown>): { trial?: string } => {
    return {
      trial: search.trial ? String(search.trial) : undefined,
    };
  },
});

// Create the route tree
const routeTree = rootRoute.addChildren([indexRoute, jobDetailRoute]);

// Create the router - use hash history in production for static hosting compatibility
const router = createRouter({ 
  routeTree,
  history: isProduction ? hashHistory : undefined,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return <RouterProvider router={router} />;
}

export default App;
